import * as React from 'react';
import { clsx } from 'clsx';

type Props = Readonly<{
	className?: string,
	innerClassName?: string,
	// An optional card rendered above the main content card in the same column — used for
	// the discount banner so it reads as its own card, not a header on this one.
	banner?: React.ReactNode,
	children?: React.ReactNode
}>;

function ColumnMain({
	children,
	className = '',
	innerClassName = 'p-6 sm:p-8',
	banner
}: Props) {

	return (<>
		<div className={clsx(className, "px-3 sm:px-4 w-full lg:w-3/5 mb-6 sm:mb-8 lg:mb-16 xl:mb-24 flex flex-col")}>
			{banner && <div className="mb-4 sm:mb-6">{banner}</div>}
			<div className="bg-white text-black rounded-3xl overflow-hidden grow">
				<div className={innerClassName}>
					{children}
				</div>
			</div>
		</div>
	</>);
}

export default ColumnMain;
